import { onMounted, onUnmounted, type Ref } from 'vue';

/** Run a callback when a click happens outside the referenced element. */
export function onClickOutside(target: Ref<HTMLElement | null>, handler: (event: MouseEvent) => void) {
  function onDocClick(e: MouseEvent) {
    const el = target.value;
    if (!el) return;
    if (e.target instanceof Node && !el.contains(e.target)) handler(e);
  }
  onMounted(() => document.addEventListener('mousedown', onDocClick));
  onUnmounted(() => document.removeEventListener('mousedown', onDocClick));
}
